import axios from "axios"

export function getDealerInvitedSummary (parameters) {
  return new Promise((resolve, reject) => {
    axios.post(`/distributor/admin/api/v1/dealership/get-dealer-invited-summary`, {
      period: parameters.period,
      start_date: parameters.start_date,
      end_date: parameters.end_date,
      dealer_uuid: parameters.dealer_uuid,
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};